var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('organization-header',{attrs:{"with-breadcrumbs":false,"with-navigation-items":false}}),(_vm.loading)?_c('spinner',{attrs:{"with-overlay":"","large":"","active":""}}):_c('organization-members',{attrs:{"member-route":"me-organization-member-view","edit-member-route":"me-organization-member-edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }